import { FC } from 'react';
import { Tooltip } from 'antd';
import styled from './index.module.scss';

interface IProp {
    text: string;
}

const QuestionIcon: FC<IProp> = ({ text }) => {
    return (
        <span className={styled.QuestionIcon}>
            <Tooltip title={text}>
                <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12.5 21.5C17.4706 21.5 21.5 17.4706 21.5 12.5C21.5 7.52944 17.4706 3.5 12.5 3.5C7.52944 3.5 3.5 7.52944 3.5 12.5C3.5 17.4706 7.52944 21.5 12.5 21.5Z"
                        fill="black"
                    />
                    <path
                        d="M9.58984 9.50008C9.82495 8.83175 10.289 8.26819 10.8998 7.90921C11.5106 7.55024 12.2287 7.41902 12.927 7.53879C13.6253 7.65857 14.2587 8.02161 14.7149 8.56361C15.1712 9.10561 15.4209 9.7916 15.4198 10.5001C15.4198 12.5001 12.4198 13.5001 12.4198 13.5001V15.0001"
                        stroke="white"
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path d="M12.5 17.5H12.51" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </Tooltip>
        </span>
    );
};

export default QuestionIcon;
